
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { AccountingPlanModel } from './Entities.Accounting.AccountingPlan';
import { PriceAdjustmentModel } from './Entities.Accounting.PriceAdjustment';
import { BcDocumentLineType } from 'enums/BcDocumentLineType';
import { Model, ModelProperty } from 'models/Model';


export class AccountingPlanSetupModel extends Model<AccountingPlanSetupModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'accountingPlanSetup.property.id', isHidden: true },
		{ name: 'name', type: 'string', languageString: 'accountingPlanSetup.property.name' },
		{ name: 'productDimensionCode', type: 'string', languageString: 'accountingPlanSetup.property.productDimensionCode' },
		{ name: 'startup', type: 'number', languageString: 'accountingPlanSetup.property.startup' },
		{ name: 'exportTypeNo', type: 'string', languageString: 'accountingPlanSetup.property.exportTypeNo' },
		{ name: 'startDate', type: 'Date', languageString: 'accountingPlanSetup.property.startDate' },
		{ name: 'endDate', type: 'Date', languageString: 'accountingPlanSetup.property.endDate' },
		{ name: 'priceAdjustmentId', type: 'guid', languageString: 'accountingPlanSetup.property.priceAdjustmentId' },
		{ name: 'replacesAccountingPlanSetupId', type: 'guid', languageString: 'accountingPlanSetup.property.replacesAccountingPlanSetupId' },
		{ name: 'accountingPlans', type: 'AccountingPlanModel[]', languageString: 'accountingPlanSetup.property.accountingPlans', isHidden: true, isArray: true, isObject: true, new: () => { return new AccountingPlanModel }, properties: () => { return AccountingPlanModel.classProperties } },
		{ name: 'inverseReplacesAccountingPlanSetup', type: 'AccountingPlanSetupModel[]', languageString: 'accountingPlanSetup.property.inverseReplacesAccountingPlanSetup', isHidden: true, isArray: true, isObject: true, new: () => { return new AccountingPlanSetupModel }, properties: () => { return AccountingPlanSetupModel.classProperties } },
		{ name: 'priceAdjustment', type: 'PriceAdjustmentModel', languageString: 'accountingPlanSetup.property.priceAdjustment', isHidden: true, isObject: true, new: () => { return new PriceAdjustmentModel }, properties: () => { return PriceAdjustmentModel.classProperties } },
		{ name: 'replacesAccountingPlanSetup', type: 'AccountingPlanSetupModel', languageString: 'accountingPlanSetup.property.replacesAccountingPlanSetup', isHidden: true, isObject: true, new: () => { return new AccountingPlanSetupModel }, properties: () => { return AccountingPlanSetupModel.classProperties } },
		{ name: 'exportType', type: 'BcDocumentLineType', languageString: 'accountingPlanSetup.property.exportType' }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public productDimensionCode: string;
	public startup: number;
	public exportTypeNo: string;
	public startDate?: Date;
	public endDate?: Date;
	public priceAdjustmentId?: string;
	public replacesAccountingPlanSetupId?: string;
	public accountingPlans: AccountingPlanModel[];
	public inverseReplacesAccountingPlanSetup: AccountingPlanSetupModel[];
	public priceAdjustment?: PriceAdjustmentModel;
	public replacesAccountingPlanSetup?: AccountingPlanSetupModel;
	public exportType: BcDocumentLineType;
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.productDimensionCode = '';
		this.startup = 0;
		this.exportTypeNo = '';
		this.startDate = undefined;
		this.endDate = undefined;
		this.priceAdjustmentId = undefined;
		this.replacesAccountingPlanSetupId = undefined;
		this.accountingPlans = [];
		this.inverseReplacesAccountingPlanSetup = [];
		this.priceAdjustment = undefined;
		this.replacesAccountingPlanSetup = undefined;
		this.exportType = 0;
		
	}
	getProperties(){
		return AccountingPlanSetupModel.classProperties;
	}
}

